import ProjectSection from 'components/portfolio/sections/ProjectSection';
import background from 'assets/portfolio/apple-blueprint.jpg';
import CTAButtonGroup from './CTAButtonGroup';

export default function HiMVC() {
    return (
        <ProjectSection
            image='http://virajshahdotorg.herokuapp.com/resources/images/HiMVC.png'
            imageAlt='HiMVC Logo'
            backgroundImage={background}
            details='left'
            shade='dark'>
            <h2>HiMVC</h2>
            <p>
                iOS and macOS are known for their amazing UI and UX design. Apple created the "Human
                Interface" Guidelines to define standards for the user interface and user experience
                for their applications.
            </p>
            <p>
                HiMVC is a model-view-controller that brings the Human Interface Guidelines to all
                web applications. Similar to ReactJS, Vue, and Angular, HiMVC is a framework that
                allows you to create components. The only difference: it follows the Human Interface
                Guidelines.
            </p>
            <p>
                All websites built with HiMVC will naturally look stunning on any Apple device (and
                non-Apple devices).
            </p>

            <CTAButtonGroup />
        </ProjectSection>
    );
}
